import React from "react";
import PopupBodyItem from "../../Helpers/Popup/PopupParts/PopupBodyItem";
import { formatDate } from "../../../JsHelpers/DateFormat";
import trans from "../../../utils";

export default function DriverDetails({ values = {} }) {
	const getValue = (value, defaultValue = "-----") =>
		value ? value : defaultValue;

	const {
		name = "",
		code = "",
		idNo = "",
		contractStartDate = "",
		contractExpireDate = "",
		contractExpireReminder = false,
		licenseExpireReminder = false,
		phoneNumber = "",
		emergencyPhoneNumber = "",
		licenseNo = "",
		address = "",
		licenseStartDate,
		licenseExpireDate,
	} = values;

	const formattedLicenseStartDate = licenseStartDate
		? formatDate(licenseStartDate).formattedDate
		: "-----";
	const formattedLicenseExpireDate = licenseExpireDate
		? formatDate(licenseExpireDate).formattedDate
		: "-----";
	const formattedContractStartDate = contractStartDate
		? formatDate(contractStartDate).formattedDate
		: "-----";
	const formattedContractExpireDate = contractExpireDate
		? formatDate(contractExpireDate).formattedDate
		: "-----";

	const getOnOffStatus = (status) => (status ? "ON" : "OFF");

	return (
		<>
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("Driver Details")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<div className="display-border">
						<PopupBodyItem title={trans("Driver Name")} item={getValue(name)} />
						<PopupBodyItem title={trans("Driver Code")} item={getValue(code)} />
						<PopupBodyItem title={trans("ID number")} item={getValue(idNo)} />
						<PopupBodyItem
							title={trans("license start date")}
							item={formattedLicenseStartDate}
						/>
						<PopupBodyItem
							title={trans("license expiry date")}
							item={formattedLicenseExpireDate}
						/>
						{/* <PopupBodyItem
              title={trans("license Expire Reminder")}
              item={getOnOffStatus(licenseExpireReminder)}
            /> */}
						<PopupBodyItem title={trans("Address")} item={getValue(address)} />
					</div>
				</div>
				<div className="col-lg-6">
					<div className="display-border">
						<PopupBodyItem
							title={trans("phone number")}
							item={getValue(phoneNumber)}
						/>
						<PopupBodyItem
							title={trans("Emergency Number")}
							item={getValue(emergencyPhoneNumber)}
						/>
						<PopupBodyItem
							title={trans("license number")}
							item={getValue(licenseNo)}
						/>
						<PopupBodyItem
							title={trans("Contract start date")}
							item={formattedContractStartDate}
						/>
						<PopupBodyItem
							title={trans("Contract expiry date")}
							item={formattedContractExpireDate}
						/>
						{/* <PopupBodyItem
              title={trans("Contract Expire Reminder")}
              item={getOnOffStatus(contractExpireReminder)}
            /> */}
					</div>
				</div>
			</div>
		</>
	);
}
